<template>
  <app-banner :edition="edition" />
  <app-sub-banner>
    <template v-slot:filters>
      <the-pictures-filter v-if="edition !== '2026'" v-model="ceremony" />
      <the-pictures-filter-new v-else v-model="ceremony" />
      <the-mobile-pictures-filter
        v-if="edition !== '2026'"
        v-model="ceremony"
      />
      <the-mobile-pictures-filter-new v-else v-model="ceremony" />
    </template>
    <template v-slot:languageSwitcher>
      <the-language-switcher />
    </template>
  </app-sub-banner>
  <the-no-pictures-message v-if="filteredPictures.length === 0" />
  <the-pictures-list
    v-else
    :pictures="filteredPictures"
    @selectPicture="(index) => (currentPictureIndex = index)"
  />
  <the-pictures-swiper
    v-show="currentPictureIndex !== null"
    :pictures="filteredPictures"
    :current-picture-index="currentPictureIndex"
    @close="currentPictureIndex = null"
  />
  <app-footer :edition="edition" />
</template>

<script>
import AppBanner from "@/components/AppBanner";
import AppSubBanner from "@/components/AppSubBanner";
import ThePicturesFilter from "@/components/ThePicturesFilter";
import ThePicturesFilterNew from "@/components/ThePicturesFilterNew";
import TheMobilePicturesFilter from "@/components/TheMobilePicturesFilter";
import TheMobilePicturesFilterNew from "@/components/TheMobilePicturesFilterNew";
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher";
import ThePicturesList from "@/components/ThePicturesList";
import TheNoPicturesMessage from "@/components/TheNoPicturesMessage";
import ThePicturesSwiper from "@/components/ThePicturesSwiper";
import AppFooter from "@/components/AppFooter";

export default {
  components: {
    AppBanner,
    AppSubBanner,
    ThePicturesFilter,
    ThePicturesFilterNew,
    TheMobilePicturesFilter,
    TheMobilePicturesFilterNew,
    TheLanguageSwitcher,
    ThePicturesList,
    TheNoPicturesMessage,
    ThePicturesSwiper,
    AppFooter,
  },
  props: {
    edition: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pictures: [],
      ceremony: null,
      currentPictureIndex: null,
      baseUrl: "",
    };
  },
  computed: {
    filteredPictures() {
      if (!this.ceremony) {
        return this.pictures;
      }

      return this.pictures.filter(
        (picture) => picture.field_ceremony == this.ceremony
      );
    },
  },
  methods: {
    async getData() {
      const result = await fetch(
        `${this.baseUrl}/pictures?_format=json&edition=${this.edition}`
      );
      const finalResult = await result.json();
      this.pictures = finalResult;
    },
  },
  mounted() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL;
    this.getData();
  },
};
</script>
